import React, { Component } from 'react';
import { Button, Col, Row } from 'reactstrap';
import { fbManufacturers, fbProducts, fbLooper} from '../../../firebase';
import OneCard from './onecard.js';

class Cards extends Component {

    state={
        robots:[],
        pageFirstLoad:true,
        manufacturers:[],
        lastElement:null,
        loadMoreText: true
    }

    loadManufacturers = () => {
        let manufacturers;
        if(this.state.manufacturers.length<1){
            fbManufacturers.once('value').then((snap)=>{
                manufacturers = fbLooper(snap);
                this.setState({
                    manufacturers
                });
            });
        }
    }

    loadRobots = () => {
        if(this.state.lastElement){
            fbProducts.orderByKey()
                .startAt(this.state.lastElement.id)
                .limitToFirst(5)
                .once('value').then((snap)=>{
                    let robots = fbLooper(snap);
                    robots.shift();
                    let loadMoreText = true;
                    if(robots.length<4){
                        loadMoreText = false;
                    }
                    this.setState({
                        robots: [...this.state.robots, ...robots],
                        lastElement: robots[robots.length-1],
                        loadMoreText
                    });
                });
        }else{
            if(this.state.pageFirstLoad){
                fbProducts.orderByKey()
                    .limitToFirst(4)
                    .once('value')
                    .then((snap)=>{
                        let robots = fbLooper(snap);
                        this.setState({
                            robots: [...this.state.robots, ...robots],
                            lastElement: robots[robots.length-1],
                            pageFirstLoad: false
                        });
                    });
            }
        }
    }

    findManufacturerName = (manufacturer_id) => {
        let {manufacturers} = this.state;
        return manufacturers.find((element)=>{
            return element.id === manufacturer_id;
        }).name;
    }
    
    componentDidMount(){
        this.loadManufacturers();
        this.loadRobots();
    }

    showCards = () => {
        if(this.state.robots.length<1){
            return null;
        }
        return this.state.robots.map((item, i)=>{
            return (
                <Col sm="3" key={i}>
                    <OneCard 
                    imageAlt={item.name + item.model}
                    imageSrc={item.image} 
                    cardTitle={item.name} 
                    cardSubtitle={item.model} 
                    cardText={item.details} 
                    manufacturer={this.findManufacturerName(item.manufacturer_id)}
                    btnText="Details" 
                    robot_id={item.id}
                    user={this.props.user}
                    />
                </Col>
            );
        });
    }

    render() {
        return (
            <div>
                <Row>
                    {this.showCards()}
                </Row>
                <Row>
                    <Col sm="12">
                    <br/>
                        {this.state.loadMoreText ?
                            <Button color="primary" block onClick={(e)=>{
                                this.loadRobots();
                            }}>Load More...</Button>
                            : null
                        }
                    </Col>
                </Row>
            </div>
        );
    }
}

export default Cards;


// WEBPACK FOOTER //
// ./src/components/widgets/cards/cards.js